import { render, staticRenderFns } from "./LockTokens.vue?vue&type=template&id=7348239d&scoped=true"
import script from "./LockTokens.vue?vue&type=script&lang=js"
export * from "./LockTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7348239d",
  null
  
)

export default component.exports